import { Seo } from "@/components/site/Seo";
import { PageShell } from "@/components/site/PageShell";
import { Hero } from "@/components/site/Hero";
import { Slideshow } from "@/components/site/Slideshow";
import { TrustMarquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { CommercialFitout } from "@/components/site/CommercialFitout";
import { TrustBand } from "@/components/site/TrustBand";
import { TrustedBy } from "@/components/site/TrustedBy";
import { ServiceArea } from "@/components/site/ServiceArea";
import { Testimonials } from "@/components/site/Testimonials";
import { FAQ } from "@/components/site/FAQ";
import { Contact } from "@/components/site/Contact";
import { FAQS, TESTIMONIALS } from "@/data/site";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

const businessExtra = {
  aggregateRating: { "@type": "AggregateRating", ratingValue: "5.0", reviewCount: "40", bestRating: "5" },
  review: TESTIMONIALS.map((t) => ({
    "@type": "Review",
    author: { "@type": "Person", name: t.name },
    reviewRating: { "@type": "Rating", ratingValue: "5", bestRating: "5" },
    reviewBody: t.quote,
  })),
};

export default function Home() {
  return (
    <PageShell>
      <Seo
        title="Electrician in Bradford & West Yorkshire | Aims Electrical"
        description="Trusted local electrician covering Bradford, Leeds, Huddersfield & across West Yorkshire. Rewires, CCTV, fire alarms, fault finding & 24/7 emergency call-outs. Call 07907 917 551."
        path="/"
        extraSchema={[faqSchema]}
        businessExtra={businessExtra}
      />
      <Hero />
      <Slideshow />
      <TrustMarquee />
      <Services />
      <CommercialFitout />
      <TrustBand />
      <TrustedBy />
      <ServiceArea />
      <Testimonials />
      <FAQ />
      <Contact />
    </PageShell>
  );
}
